export const noop = () => {};

export const prevent = (e) => {
  if (e && e.preventDefault) {
    e.preventDefault();
    e.stopPropagation();
  }
};
